// @ts-check

/**
 * Renders the photographer about section as an editorial magazine spread:
 * sticky name + pull quote aside, bio with drop cap, gear sidebar, stats row.
 */
export class AboutSection {
  /**
   * @param {HTMLElement} container
   * @param {Object} data
   */
  constructor(container, data) {
    this.container = container;
    this.data = data;
    this.render();
  }

  render() {
    const gear = Array.isArray(this.data.gear) ? this.data.gear : [];

    this.container.innerHTML = `
      <div class="about-grid">
        <aside class="about-aside">
          <p class="about-kicker">The Photographer</p>
          <p class="about-name">${this.data.name ?? 'Cast in Exile'}</p>
          <blockquote class="about-quote">
            <p>“${this.data.philosophy ?? ''}”</p>
          </blockquote>
        </aside>
        <div class="about-main">
          <p class="about-lead">${this.data.bio ?? ''}</p>
          <h3 class="about-heading">装备志 · Gear</h3>
          <ul class="about-gear">
            ${gear.map((item) => `<li>${item}</li>`).join('')}
          </ul>
          <div class="about-stats-row">
            <div class="about-stat">
              <span class="about-stat-number">3</span>
              <span class="about-stat-label">Spirit Halls</span>
            </div>
            <div class="about-stat">
              <span class="about-stat-number">19</span>
              <span class="about-stat-label">Selected Works</span>
            </div>
            <div class="about-stat">
              <span class="about-stat-number">1</span>
              <span class="about-stat-label">Walk-through</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
